import axios from 'axios';

export default {
  FETCH_PINNEDMSGS ({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            // axios.post('login/authenticate', payload)
            axios.get('corporations/getAllAdminMessages')
                .then((response) => {
                    const { data: { data : { payload } } } = response;
                    localStorage.setItem('pinnedmsgs', JSON.stringify(payload));
                    commit('SET_PINNEDMSGS', payload);
                    commit('TOGGLE_LOADING', false);
                    resolve(payload);

                })
                .catch((error) => {
                    console.log('action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    },
    GETSELECTEDPINNEDMSG ({ commit }, corpAdminMessageId) {
        commit('TOGGLE_LOADING', true);
        return axios.get(`corporations/getAllAdminMessages`).then((response) => {
            commit('TOGGLE_LOADING', false);
            const { data: { data : { payload }} } = response;

            console.log('payload', payload)
            let selectedMsg = payload.filter(x => {
              return x.corpAdminMessageId.toString() === corpAdminMessageId.toString()
            });
            console.log('found pinned msg', selectedMsg)
            commit('SET_SELECTED_PINNEDMSG', selectedMsg[0])
        }, (err) => {
            commit('TOGGLE_LOADING', false);
            console.log('err ', err)
        })
    },
    ADD_PINNEDMSG({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            console.log("add msg payload : ", payload);
            axios.post('corporations/insertAdminMessage', payload)
                .then((response) => {
                    console.log('ADD_PINNEDMSG action fetch response : ', response);
                    const { data: { data } } = response;
                    commit('TOGGLE_LOADING', false);
                    resolve(data);
                })
                .catch((error) => {
                    console.log('ADD_PINNEDMSG action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    },
  UPDATE_PINNEDMSG({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            axios.post('/corporations/updateCorporationAdminMessages', payload)
                .then((response) => {
                    const { data: { data } } = response;
                    commit('TOGGLE_LOADING', false);
                    resolve(data);
                })
                .catch((error) => {
                    console.log('UPDATE_PRESS action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/pinned/actions.js